import { Outlet, useOutletContext } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import FoldersSettings from 'modules/documents/components/Settings/Folders'
import { SPACES } from 'modules/documents/lib/constants'

interface OutletContext {
  canManagePublicCompanyFolders: boolean
}

const PublicCompanyFolderSettingPage = () => {
  const space = SPACES.COMPANY_PUBLIC
  const folderVariables = { space, rootFolders: true }
  const { company } = useCurrentSession()
  const { navigation } = useNavigation()
  const { canManagePublicCompanyFolders } = useOutletContext<OutletContext>()

  return (
    <>
      <Outlet
        context={{
          parentRoute: navigation.settings.folders.public.fullPath(),
          space,
          companyId: company.id,
        }}
      />

      <FoldersSettings
        space={space}
        folderVariables={folderVariables}
        canManage={canManagePublicCompanyFolders}
        newFolderRoute={navigation.settings.folders.public.new.fullPath()}
      />
    </>
  )
}

export default PublicCompanyFolderSettingPage
